import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { motion } from 'framer-motion';
import { useRef, KeyboardEvent } from 'react';
interface Props {
  tabs: {
    id: number;
    label?: string;
  }[];
  activeTab: number;
  sectionRef: React.RefObject<HTMLDivElement | null>;
}
const CARD_HEIGHT = 560;
export function Tabs(props) {
  const $ = _c(2);
  const {
    activeTab,
    tabs,
    sectionRef
  } = props;
  const ref = useRef(null);
  const tabRefs = useRef(new Map());
  const scrollToTab = tabId => {
    const sectionTop = sectionRef.current?.getBoundingClientRect().top || 0;
    const top = window.scrollY + sectionTop + tabId * CARD_HEIGHT - 50;
    window.scrollTo({
      top,
      behavior: "smooth"
    });
  };
  const handleKeyDown = (event, currentIndex) => {
    let newIndex;
    bb17: switch (event.key) {
      case "ArrowLeft":
        {
          event.preventDefault();
          newIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
          break bb17;
        }
      case "ArrowRight":
        {
          event.preventDefault();
          newIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
          break bb17;
        }
      case "Home":
        {
          event.preventDefault();
          newIndex = 0;
          break bb17;
        }
      case "End":
        {
          event.preventDefault();
          newIndex = tabs.length - 1;
          break bb17;
        }
      default:
        {
          return;
        }
    }
    const newTab = tabs[newIndex];
    tabRefs.current.get(newTab.id)?.focus();
    scrollToTab(newTab.id);
  };
  const t0 = "tablist";
  const t1 = "sticky top-24 z-10 hidden space-x-1 rounded-full bg-white md:flex xl:top-36";
  const t2 = tabs.map((tab, index) => {
    const isSelected = activeTab === tab.id;
    return <button key={tab.id} ref={el => {
      if (el) {
        tabRefs.current.set(tab.id, el);
      }
    }} role="tab" aria-selected={isSelected} aria-controls={`panel-${tab.id}`} tabIndex={isSelected ? 0 : -1} onClick={() => scrollToTab(tab.id)} onKeyDown={e => handleKeyDown(e, index)} className={mergeClasses(activeTab === tab.id ? "" : "hover:text-blue-300/60", "relative w-36 rounded-full px-6 py-4 text-sm font-medium text-blue-300 transition focus-visible:outline-2")}><span className={mergeClasses(activeTab === tab.id ? "text-white" : "text-blue-300", "relative z-10 text-sm font-semibold")}>{tab.label || ""}</span>{activeTab === tab.id && <motion.span layoutId="bubble" className="absolute inset-0 z-0 rounded-full bg-blue-500" transition={{
        type: "spring",
        bounce: 0.2,
        duration: 0.6
      }} aria-hidden="true" />}</button>;
  });
  let t3;
  if ($[0] !== t2) {
    t3 = <div ref={ref} role={t0} className={t1}>{t2}</div>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
}